<script>
export default {
  props: ["clr"]
};
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.75098 9.25C3.75098 10.2629 5.80248 11.0833 8.33431 11.0833"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33339 14.75C5.80248 14.75 3.75098 13.9295 3.75098 12.9166"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.0845 15.6666C11.0845 16.6795 13.136 17.5 15.6678 17.5C18.1996 17.5 20.2511 16.6795 20.2511 15.6666"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.0845 12C11.0845 13.0129 13.136 13.8333 15.6678 13.8333C18.1996 13.8333 20.2511 13.0129 20.2511 12"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.6665 10.1666C13.1365 10.1666 11.0831 10.987 11.085 12"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.0845 12V19.3333C11.0845 20.3462 13.136 21.1667 15.6678 21.1667"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.6665 10.1666C18.1965 10.1666 20.2498 10.987 20.248 12"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.2498 12V19.3333C20.2498 20.3462 18.1983 21.1667 15.6665 21.1667"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.33333 18.4167C5.80242 18.4167 3.75 17.5963 3.75 16.5834"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.9633 7.085C10.6662 7.16842 10.3431 7.23808 10 7.29169C9.48345 7.37238 8.92132 7.41667 8.33333 7.41667C5.80203 7.41667 3.75 6.59586 3.75 5.58333C3.75 4.57081 5.80203 3.75 8.33333 3.75C8.49864 3.75 8.66191 3.7535 8.82269 3.76033C8.88214 3.76285 8.94125 3.76583 9 3.76925"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.74984 5.58337V16.5834"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.9545 6.45142C15.9603 6.5024 15.9259 6.54668 15.875 6.55362C15.445 6.61237 13.5375 6.80219 12.2206 5.77829C10.9037 4.75438 10.6176 2.85892 10.5685 2.42764C10.5627 2.37666 10.5971 2.33238 10.648 2.32544C11.0781 2.2667 12.9856 2.07687 14.3024 3.10077C15.6193 4.12468 15.9054 6.02014 15.9545 6.45142Z"
      stroke="#768391"
      stroke-width="1.25"
    />
    <line
      x1="15.75"
      y1="6.75"
      x2="15.75"
      y2="9.25"
      stroke="#768391"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M21.2404 3.2877C21.2915 3.29268 21.3276 3.33559 21.3238 3.38676C21.2914 3.81962 21.0787 5.72472 19.8024 6.79873C18.5261 7.87274 16.6127 7.75675 16.1806 7.71467C16.1296 7.70969 16.0935 7.66678 16.0973 7.61561C16.1297 7.18275 16.3424 5.27765 17.6187 4.20364C18.895 3.12963 20.8084 3.24562 21.2404 3.2877Z"
      stroke="#768391"
      stroke-width="1.25"
    />
  </svg>
</template>
